import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { Button } from './ui';
import ScrollToTop from './ScrollToTop';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';

const SiemprePagoWrapper = ({ children }: { children: any }) => {

  React.useEffect(() => {
    /* eslint-disable no-undef */
    PWCheckout.AddActionButton("btnPayHidden");
  });

  return (
    <>
      <Button id="btnPayHidden" style={{ display: 'none' }} />
      {children}
    </>
  );
}

const Root = ({ store }) => (
	<Provider store={store}>
		<Router>
			<SiemprePagoWrapper>
				<ScrollToTop>
					<GoogleReCaptchaProvider
						reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
						language="es"
					>
						<App />
						<ToastContainer
							position={toast.POSITION.TOP_RIGHT}
							autoClose={5000}
							transition={Slide}
							hideProgressBar
							closeOnClick
						/>
					</GoogleReCaptchaProvider>
				</ScrollToTop>
			</SiemprePagoWrapper>
		</Router>
	</Provider>
);

export default Root;
